/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ActivityContent, ActivityIconName, ActivityItem, ActivityTabCategory } from './useActivityTransformer';
import type { ScheduledActionType } from '@/api/entity_types/ScheduledAction';

export const useTransformScheduledAction = () => {
  const transformScheduledAction = (scheduledAction: any): ActivityItem => {
    const styles: Record<
      ScheduledActionType,
      { icon: ActivityIconName; category: ActivityTabCategory; label: string; verb: string; typeLabel: string }
    > = {
      send_email: {
        icon: 'mail',
        category: 'emails',
        label: 'Scheduled Email',
        verb: 'scheduled an email',
        typeLabel: 'Scheduled Email',
      },
      send_sms: {
        icon: 'message-square',
        category: 'notes',
        label: 'Scheduled Message',
        verb: 'scheduled a message',
        typeLabel: 'Scheduled Message',
      },
    };

    const { icon, category, label, verb, typeLabel } = styles[scheduledAction.action_type as ScheduledActionType];
    const { subject, body, files } = scheduledAction.action_params;

    const content: ActivityContent[] = [{ label: 'Status', richText: scheduledAction.status }];
    if (subject) content.push({ label: 'Subject', richText: subject });
    if (body) content.push({ richText: body });
    if (files) {
      content.push({ label: 'Files', richText: files.map((file: any) => file.original_filename) });
    }

    return {
      category,
      icon,
      verb,
      typeLabel,
      label,
      id: scheduledAction.id,
      displayTimestamp: scheduledAction.invoke_on,
      sortTimestamp: scheduledAction.invoke_on,
      actor: scheduledAction.scheduler_user.name ?? scheduledAction.scheduler_user.email ?? '',
      content: content,
      buttons: [{ title: 'Cancel', action: { emitId: 'cancel-scheduled-action-clicked' } }],
    };
  };

  return { transformScheduledAction };
};
